module.exports = __webpack_public_path__ + "static/img/icon_help.ddc81123.png";